
export default function WhyChooseUs() {
  const stats = [
    {
      icon: 'ri-building-2-line',
      number: '500+',
      label: 'Projects Completed'
    },
    {
      icon: 'ri-map-pin-line',
      number: '15+',
      label: 'States Covered'
    },
    {
      icon: 'ri-handshake-line',
      number: '50+',
      label: 'Brand Partners'
    },
    {
      icon: 'ri-time-line',
      number: '10+',
      label: 'Years Experience'
    }
  ];

  const features = [
    {
      icon: 'ri-star-line',
      title: 'Brand-agnostic Strength',
      description: 'Access to best-in-class products from multiple manufacturers, giving you the flexibility to choose what works best.'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Technical Depth',
      description: 'Our experts analyze site conditions and recommend solutions, not just products, ensuring optimal results.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Flexibility & Agility',
      description: 'Quick response to urgent demands and alternate sourcing capabilities to keep your projects moving.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Transparent & Ethical',
      description: 'Clear pricing, compliance, and traceability in all our business operations and partnerships.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability & Innovation',
      description: 'Focus on eco-friendly solutions, low-carbon materials, and next-generation construction technologies.'
    },
    {
      icon: 'ri-award-line',
      title: 'Certified Expertise',
      description: 'Our team is trained and certified on global standards of construction chemistry and best practices.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Why Choose Lavin Enterprises & Co.
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Discover what sets us apart as India's leading construction chemical distributor and solution provider.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div 
                  className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4"
                  style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}
                >
                  <i className={`${stat.icon} text-2xl`} style={{ color: '#7E887E' }}></i>
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {features.map((feature, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
                <div 
                  className="w-16 h-16 flex items-center justify-center rounded-full mb-6"
                  style={{ backgroundColor: 'rgba(126, 136, 126, 0.1)' }}
                >
                  <i className={`${feature.icon} text-2xl`} style={{ color: '#7E887E' }}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Reach Section */}
          <div 
            className="rounded-2xl p-8 md:p-12 text-white"
            style={{ background: 'linear-gradient(to right, #7E887E, #6B756B)' }}
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-6">Our Reach & Footprint</h3>
                <p className="text-xl mb-6 opacity-90 leading-relaxed">
                  With operations across India, we maintain warehouses and distribution hubs in key regions to ensure consistent and timely supply.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-xl mr-3 text-gray-200"></i>
                    <span>Delhi NCR, Uttar Pradesh, Rajasthan</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-xl mr-3 text-gray-200"></i>
                    <span>Gujarat, Maharashtra & Beyond</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-handshake-line text-xl mr-3 text-gray-200"></i>
                    <span>Regional Partnerships & Government Projects</span>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <img
                  src="https://readdy.ai/api/search-image?query=India%20map%20showing%20distribution%20network%20with%20warehouse%20locations%2C%20logistics%20hubs%20marked%20across%20different%20states%2C%20professional%20supply%20chain%20visualization%2C%20modern%20distribution%20centers%20and%20delivery%20trucks%2C%20pan-India%20coverage%20representation&width=500&height=400&seq=reach1&orientation=landscape"
                  alt="Pan-India Distribution Network"
                  className="w-full h-80 object-cover rounded-xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
